import * as memberManagement from '../services/memberManagement';

export default {
  namespace: 'ruleginMM',

  state: {
    userInfo: null,
    getMemberList: null,
    addMember: null,
    deleteRule: null,
    logList: null,
    uploadFile: null,
  },

  effects: {
    *getMemberList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.getMemberList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          getMemberList: response,
        },
      });
    },

    *addMember({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(memberManagement.addMember, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addMember: response,
        },
      });
    },

    *editMember({ payload: { modelId, values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.editMember,
        modelId,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {},
      });
    },

    *deleteModel({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.deleteModel,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRule: response,
        },
      });
    },

    *exportModel({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.exportModel,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          // deleteRule: response,
        },
      });
    },

    // 操作日志
    *getLog({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(memberManagement.getLog, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          logList: response,
        },
      });
    },

    // 上传
    *uploadFile({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.uploadFile,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          uploadFile: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
